import {
  Box,
  HStack,
  Skeleton,
  SkeletonCircle,
  VStack,
} from '@chakra-ui/react';

/**
 * Skeleton loading state for journal entry cards.
 * Mimics the structure of JournalEntryCard for a consistent loading experience.
 */
export const JournalEntryCardSkeleton: React.FC = () => {
  return (
    <Box
      bg="bg.default"
      borderRadius="lg"
      border="1px solid"
      borderColor="border.default"
      p={3}
    >
      <VStack align="stretch" spacing={2}>
        {/* Header Row */}
        <HStack justify="space-between" align="center">
          <HStack spacing={2}>
            <SkeletonCircle size="5" />
            <Skeleton height="20px" width="80px" borderRadius="md" />
          </HStack>
          <Skeleton height="16px" width="60px" />
        </HStack>

        {/* Body content */}
        <VStack align="stretch" spacing={2}>
          <Skeleton height="16px" width="100%" />
          <Skeleton height="16px" width="85%" />
        </VStack>
      </VStack>
    </Box>
  );
};

JournalEntryCardSkeleton.displayName = 'JournalEntryCardSkeleton';
